import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { TokenAuthCreateRow, TokenAuthRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface TokenAuthEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class TokenAuthEditPage extends Component<TokenAuthEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSABoxSecret_Token = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <CredentialLayout<TokenAuthRow, TokenAuthCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit a Token Auth credential by updating its name, token, or description. The token is kept as a protected secret, and any application set up to use the credential applies the updated value." : "This section allows you to create a Token Auth credential for services that authenticate with an API token (bearer token) by entering a name and the token. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then authenticate API requests.",
                }}
                pages={{
                    entity: CredentialEntities.token_auth(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): TokenAuthCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let token = this.NSABoxSecret_Token.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            token,
                                            description,
                                            token_auth_category: [],
                                            token_auth_field: [],
                                            token_auth_tag: [],
                                        };
                                    },
                                    setRow: (row: TokenAuthRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSABoxSecret_Token.current?.setValue(row.token_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        auto_complete="new-password"
                        style={{ width: NSBox.width.double }}
                    />
                    <NSABoxSecret
                        {...this.props}
                        ref={this.NSABoxSecret_Token}
                        required
                        title="Token"
                        auto_complete="new-password"
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </CredentialLayout >
        );
    }
}